/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { get, isArray, isEmpty, isEqual } from "lodash";

import { getVacationsMyList } from "../../../apis/vacation/vacations";
import Form from "../../../components/Form";

import Modal, { ModalHeader } from "../../../components/Modal";
import useForm from "../../../hooks/useForm";

import { getDay, getDateRangeList } from "../../../utils/date";
import Select from "../../../components/Select";
import Button from "../../../components/Button";
import {
  createVacationsPlan,
  modifyVacationsPlan,
} from "../../../apis/vacation/vacation-plan";
import systemAlert from "../../../utils/systemAlert";

export const getVacationList = async () => {
  const vacationsMyListData = await getVacationsMyList({
    search: {
      isExpired: false,
    },
    offset: 0,
    limit: 999,
  });

  const vacationsMyList = get(vacationsMyListData, "data.vacations", []).filter((vacation) => vacation.usableCount !== 0).map(
    (item) => ({
      label: item.title,
      value: String(item.vacationIdx),
    })
  );
  const defaultVacation = get(vacationsMyList, "[0].value");

  const fields = [
    {
      title: "휴가유형",
      key: "vacationIdx",
      type: "select",
      required: true,
      width: 400,
      options: {
        list: vacationsMyList,
      },
    },

    {
      title: "휴가 기간",
      key: "dates",
      type: "datepicker",
      options: {
        mode: "range",
        dateFormat: "Y-m-d",
      },
      required: true,
    },
  ];

  const defaultForm = {
    vacationIdx: defaultVacation,
    dates: [getDay(), getDay()],
  };

  const submit = (form, type, planIdx, submitAction) => {
    switch (type) {
      case "create":
        systemAlert('새 휴가계획을 작성하시겠습니까?', {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '작성',
              onClick: () => {
                createVacationsPlan(form)
                  .then(() => {
                    submitAction.listSubmit()
                    submitAction.cancel()
                  })
                  .catch(() => { });
              }
            }
          ]
        })
        break;
      case "modify":
        //console.log(form)
        systemAlert('해당 휴가계획을 수정하시겠습니까?', {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '수정',
              onClick: () => {
                modifyVacationsPlan(planIdx, form)
                  .then(() => {
                    submitAction.listSubmit()
                    submitAction.cancel()
                  })
                  .catch(() => { });
              }
            }
          ]
        })
        break;
      default:
        break;
    }
  };

  return {
    fields,
    defaultForm,
    submit,
  };
};

const VacationPlan = ({
  detailOpen,
  setDetailOpen,
  listSubmit,
  data,
  setData,
  mode,
  setMode
}) => {
  const [formFields, setFormFields] = useState([]);
  const [vacation, setVacation] = useState(null);
  const [vacationSchedule, setVacationSchedule] = useState([]);

  const _setVacation = async () => {
    const _vacation = await getVacationList();
    setVacation(_vacation);
  };

  useEffect(() => {
    _setVacation();
  }, []);

  useEffect(() => {
    if (vacation) {
      setFormFields(vacation.fields);
      setForm(vacation.defaultForm);
      setOriginForm(vacation.defaultForm);
    }
  }, [vacation]);

  useEffect(() => {
    if (!isEmpty(data)) {
      setForm({
        employeeIdx: String(data.employeeIdx),
        vacationIdx: String(data.vacationIdx),
        dates: [data.startDate, data.endDate],
      });
      setOriginForm({
        employeeIdx: String(data.employeeIdx),
        vacationIdx: String(data.vacationIdx),
        dates: [data.startDate, data.endDate],
      })
    }
  }, [data]);

  const submit = (_form) => {
    const { vacationIdx, employeeIdx } = _form;

    if (!vacation.submit) {
      console.error("vacation 에 submit() 가 없습니다.");
      return;
    }

    vacation.submit(
      {
        employeeIdx,
        vacationIdx,
        vacationSchedule,
      },
      mode,
      get(data, "planIdx"),
      {
        listSubmit,
        cancel
      }
    );
  };

  const {
    form,
    setForm,
    originForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
  } = useForm({}, submit);

  const cancel = () => {
    setDetailOpen(false);
    setForm(vacation.defaultForm);
    setData({});
    setMode("create");
  };

  useEffect(() => {
    if (mode === "create") {
      if (form && form.dates && form.dates.length === 2) {
        const startDate = form.dates[0];
        const endDate = form.dates[1];

        const _dateList = getDateRangeList(startDate, endDate).map((date) => ({
          date,
          vacationDayType: "all",
        }));

        setVacationSchedule(_dateList);
      }
    }

    if (mode !== "create" && !isEmpty(data)) {
      const sortedVacationSchedule = data.vacationSchedule.sort(
        (a, b) => new Date(a.date) - new Date(b.date)
      );
      setVacationSchedule(sortedVacationSchedule);

      if (!isEqual(form, originForm)) {
        if (form && form.dates && form.dates.length === 2) {
          const startDate = form.dates[0];
          const endDate = form.dates[1];

          const _dateList = getDateRangeList(startDate, endDate).map((date) => ({
            date,
            vacationDayType: "all",
          }));

          setVacationSchedule(_dateList);
        }
      }
    }
  }, [mode, form, data]);

  const handleSelectOnChange = (e) => {
    const { name, value } = e.target;
    //console.log(name, value)
    const tranDataList = vacationSchedule.map((d) => {
      if (d.date === name) {
        return {
          date: name,
          vacationDayType: value,
        };
      }
      return d;
    });

    setVacationSchedule(tranDataList);
  };

  return (
    <Modal size="md" isOpen={detailOpen} close={cancel}>
      <div className="vacation-plan-write">
        <ModalHeader>
          {mode === "create" ? "새 휴가 계획" : mode === "modify" ? "휴가 계획 수정" : "휴가 계획 상세"}
        </ModalHeader>
        <Form
          mode={mode}
          isRequiredShow={true}
          fields={formFields}
          form={form}
          onChange={handleOnChange}
          errors={errors}
        />
        {isArray(vacationSchedule) &&
          vacationSchedule.map((date, index) => (
            <div key={index} className="vacation-date-container">
              <div className="vacation-date-wrap">
                <div className="label-wrap">
                  <label className="vacation-date-label">{date.date}</label>
                </div>
                <div className="vertical-divider" />
                <Select
                  name={date.date}
                  className="vacation-type-select"
                  value={get(date, 'vacationDayType')}
                  list={[
                    { label: "종일", value: "all" },
                    { label: "반일", value: "half" },
                    { label: "반반일", value: "quarter" },
                    { label: "휴일", value: "none" },
                  ]}
                  onChange={(e) => handleSelectOnChange(e, index)}
                  mode={mode}
                />
              </div>
            </div>
          ))}
        <div className="submit-button-wrap float-right">
          <Button
            className="button"
            size="lg"
            label="취소"
            color="text"
            action={cancel}
          />
          {mode !== 'view' && (
            <Button
              className="button"
              size="lg"
              label={mode === "create" ? "작성완료" : "수정완료"}
              action={handleSubmit}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default VacationPlan;
